import React from 'react';

interface LogoProps {
 className?: string;
 width?: number;
 height?: number;
 color?: string;
}

const Logo = ({ className = "", width = 70, height, color, ...props }: LogoProps) => (
 <svg
   className={`logo-svg ${className}`}
   style={{
     shapeRendering: 'geometricPrecision',
     textRendering: 'geometricPrecision',
     WebkitFontSmoothing: 'antialiased',
     MozOsxFontSmoothing: 'grayscale',
   }}
   width={width}
   height={height}
   viewBox="0 0 709.34 291.46"
   xmlns="http://www.w3.org/2000/svg"
   shapeRendering="geometricPrecision"
   textRendering="geometricPrecision"
   {...props}
 >
   <g>
     <path 
       className="cls-1" 
       fill={color ?? "#104d3a"}
       d="M225.83,206.21c-.55,22.3,7.23,49.16,32.53,57.03,17.4,5.41,36.64.17,50.37-10.49,2.7-2.09,10.43-12.14,13.05-7.2,2.39,4.53-4.91,15.32-7.91,19.17-32.15,41.24-104.67,33.35-125.53-13.81-28.83-65.19,33.65-142.73,108.09-106.36l14.49,11.5L387.06.66l4.9-.66,137.32,278.45c4.97-3.85,6.57-9.92,7.42-15.62l-.04-161.37c-.85-7.03-2.73-13.8-10.21-17.05-5.78-2.51-13.9-.92-9.56-9.67,8.65-2.33,17.76-3.57,26.56-5.55,4.76-1.07,33.39-8.63,35.13-8.16.62.17,2.36,1.62,2.36,1.89v152.12c12.74-11.54,26.69-22.24,38.65-34.51,4.12-4.23,15.24-16.17,16.02-21.35,1.2-7.99-4.4-9.16-10.84-11.56-1.21-4.74-1.27-9.12,5.18-8.88l62.13.43c2.17,1.19,2.14,7.15,1.33,9.28-5.16,2.12-10.88,2.31-16.1,4.38-8.91,3.53-20.5,13.08-27.8,19.25-6.89,5.83-14.03,12.78-19.97,19.27l55.24,76.59c2.96,3.42,6.5,7.18,10.64,9.43,5.93,3.23,16.84,2,13.15,9.92h-64.69l-48.64-69.82-2.55-.86c-2.62,3.77-10.82,8-11.72,12.52-1.11,5.55-.62,25.8.07,31.98.74,6.69,3.95,13.46,10.58,16.71,2.53,1.24,11.75,2.96,12.36,3.82.92,1.3.52,5.65-.9,5.65h-158.46c-3.93-8.18,5.98-7.11,11.58-10.57,8.35-5.15,7.48-12.1,4.48-19.93-5.69-14.83-16.33-34.84-23.99-49.26-1.83-3.45-1.85-5.94-6.37-6.2-19.18-1.12-48.48,15.16-56.18,31.63-5.82,12.44-8.83,38.21,6.9,45.28,4.73,2.13,12.75,1.46,8.94,8.69h-75.65s-.7-.96-.7-.96c-1.81-6.27,4.56-5.12,8.86-7.65,10.52-6.19,14.19-28.15,18.79-38.82,10.86-25.24,33.93-42.77,61.88-50.36,2.74-.74,21.37-3.97,21.47-5l-50.76-103.16-45.86,99.68c-2.04,6.81.75,16.13-.61,22.71-.18.88-1.51,2.83-2.15,2.83h-99.42ZM290.96,191.76c.55-20.37-12.31-47.83-39.13-41.39-17.44,4.19-24.14,26.55-26.01,40.98l65.14.42Z"
     />
     <path 
       className="cls-1" 
       fill={color ?? "#104d3a"}
       d="M76.49,198.18v58.2c0,8.45,8.33,18.26,16.48,21.69,2.73,1.15,10.45,2.57,11.32,3.17,1.93,1.33.32,4.27-.02,6.04H.95c-2.69-7.5,3.41-6.28,8.3-7.98,9.89-3.44,16.73-11.49,17.78-21.29l-.14-154.06c-.93-8.12-6.33-16.8-14.65-20.17-5.97-2.41-17.46-1.1-9.56-10.44l120.3-.44c46.03,2.44,82.93,36.96,68.36,80.94-7.32,22.1-36.95,44.33-62.33,44.33h-52.53ZM76.49,185.33h24.75c53.01,0,55.63-82.73,11.96-96.95-2.12-.69-9.32-2.59-11.09-2.59h-25.61v99.54Z"
     />
   </g>
 </svg>
);

export default Logo;